module.exports = __webpack_public_path__ + "img/rang-logga.e01ced5d.png";